import store from "@/store";
import layout from "@/layouts/PanelUser";

import { routes as authRoutes } from "./auth/Routes";
import { routes as eventsRoutes } from "./events/Routes";
import { routes as routesQuantumRandomNumbers } from "./quantumRandomNumbers/Routes";

import { routes as routesWebService } from "./webService/Routes";
import { routes as routesAgahi } from "./agahi/Routes";
import { routes as routesTransactions } from "./transactions/Routes";
import { routes as routesJobPosition } from "./jobPosition/Routes";
import { routes as routesmyClasses } from "./myClasses/Routes";
import { routes as routeTeaching } from "./teaching/Routes";

const groupName =
  store.state
    .userRoutesGroupName; /* نام گروه کابری برای مدیریت داشبرد یا پنل مورد نظر */
const pathRoot =
  store.state
    .userRoutesPathRoot; /* مسیری ریشه‌ای که برای گروه کاربری در نظر گرفته‌ایم */
const parentName =
  store.state
    .userRoutesParentName; /* نام اصلی برای زیر مسیر‌های مدیریت داشبرد یا پنل مورد نظر */

// ------- Routes -------- -------- -------- -------- -------- -------- -------- //
export const routes = [
  {
    name: parentName,
    path: pathRoot,
    component: layout,
    meta: {
      requiresAuth: true,
      group: groupName,
    },
    children: [
      ...eventsRoutes(parentName),
      //...routesQuantumRandomNumbers(parentName),
      ...routesWebService(parentName),
      ...routesAgahi(parentName),
      ...routesTransactions(parentName),
      //...monitoringRoutes(parentName),
      ...routesJobPosition(parentName),
      ...routesmyClasses(parentName),
      ...routeTeaching(parentName),

      {
        path: "",
        redirect: {
          name: parentName + "-" + "Home",
        },
      },

      {
        path: "home",
        name: parentName + "-" + "Home",
        component: () => import("./Home.vue"),
      },

      {
        path: "api-prices",
        name: parentName + "-" + "Api-Prices",
        component: () => import("./ApiPrices.vue"),
      },

      {
        path: "profile",
        name: parentName + "-" + "Profile",
        component: () => import("./Profile.vue"),
      },
      {
        path: "cv",
        name: parentName + "-" + "Cv",
        component: () => import("./Cv.vue"),
      },
      {
        path: "company-profile",
        name: parentName + "-" + "Company-Profile",
        component: () => import("./CompanyProfile.vue"),
      },
      {
        path: "teacher-info",
        name: parentName + "-" + "Teacher-Info",
        component: () => import("./TeacherInfo.vue"),
      },
      {
        path: "wallet",
        name: parentName + "-" + "Wallet",
        component: () => import("./Wallet.vue"),
      },
      {
        path: "saved",
        name: parentName + "-" + "Saved",
        component: () => import("./Saved.vue"),
      },
    ],
  },

  // ####### Auth ####### ####### ####### ####### ####### ####### ####### ####### //
  /**
   * مهم:
   * چون لاگین و رجیستر از لایه پیشفرض گروه مدیریت پیروی نمی‌کنند باید خارج از فضای چیلدرن نوشته شود
   */

  ...authRoutes(parentName, pathRoot, groupName),
  // ####### END Auth ####### ####### ####### ####### ####### ####### ####### ####### //
];

// ------- END Routes -------- -------- -------- -------- -------- -------- -------- //

export const middleware = (record, next, checkAuth) => {
  // ------- Check Group ------- ------- ------- ------- ------- ------- ------- //
  if (record.meta.group === groupName) {
    // ------- Check Auth ------- ------- ------- ------- ------- ------- ------- //
    if (record.meta.requiresAuth) {
      //const redirectPath = window.location.pathname; // برگشت به آدرس این صفحه
      if (checkAuth) {
        next();
      } else {
        next({
          name: `${parentName}-Login`,
          query: { redirect: window.location.pathname },
        });
      }
    }
    // ####### END Check Auth ####### ####### ####### ####### ####### ####### ####### //

    // ------- Check Auth Reverse ------- ------- ------- ------- ------- ------- ------- //
    else if (record.meta.requiresAuthReverse) {
      if (!checkAuth) {
        next();
      } else {
        next({
          name: `${parentName}-Login`,
        });
      }
    }
    // ####### END Check Auth  Reverse ####### ####### ####### ####### ####### ####### #######  //
  }
  // ####### END Check Group ####### ####### ####### ####### ####### ####### ####### //
};
